import { render, staticRenderFns } from "./ORegisterInfo.vue?vue&type=template&id=2936aaf5&scoped=true&"
import script from "./ORegisterInfo.vue?vue&type=script&lang=ts&"
export * from "./ORegisterInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ORegisterInfo.vue?vue&type=style&index=0&id=2936aaf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2936aaf5",
  null
  
)

export default component.exports